export const SET_REGISTRATION_STEP = 'SET_REGISTRATION_STEP'

export interface SetRegistrationStepAction {
    type: typeof SET_REGISTRATION_STEP;
    payload: number
}
